<template>
  <BaseToggleSwitcher
    :value="value"
    :size="size"
    @input="v => $emit('input', v)"
    fillBg="background-success-default"
    disabledBg="v1-grey-10"/>
</template>
<script>
export default {
  props: {
    value: [String, Boolean, Number, Object],
    size: {
      type: String,
      default: 'md'
    }
  }
};
</script>
<style>
</style>
